import HeaderFleetExecutionTask from "./HeaderFleetExecutionTask";
import TableLoad from "../../TableLoad";
import { useSelector } from "react-redux";
import useFleetExecutionsTask from "../../../hooks/useFleetExecutionsTask";
import FleetExecutionTaskGroup from "./FleetExecutionTaskGroup";
import FleetExecutionDashboards from "./FleetExecutionDashboards";
import buildTaskTree from "../../../utils/buildTaskTree";

interface ITableFleetExecutionTaskProps {
  fleet_execution_id: string;
  handdleViewPopUp: (value: boolean, data: any) => void;
}

export default function TableFleetExecutionTask({
  fleet_execution_id,
  handdleViewPopUp,
}: ITableFleetExecutionTaskProps) {
  const { executionTaskState, loading, errors } =
    useFleetExecutionsTask(fleet_execution_id);
  const filters = useSelector((state: any) => state.executionTask.filters);

  if (loading) return <TableLoad />;
  if (errors) return <p className="p-table-msg">Internal server error</p>;
  if (
    !executionTaskState ||
    (executionTaskState && executionTaskState.length === 0)
  )
    return <p className="p-table-msg">No data</p>;

  return (
    <>
      <HeaderFleetExecutionTask />
      <FleetExecutionTaskGroup
        group={buildTaskTree(executionTaskState.executionTask, filters)}
        fleet_execution_id={fleet_execution_id}
        handleViewPopUp={handdleViewPopUp}
      />
      <FleetExecutionDashboards tasks={executionTaskState.executionTask} />
    </>
  );
}
